export default __webpack_public_path__ + "static/media/ic-prev_Primary1.aaf689ba.svg";